const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    if (typeof window !== "undefined") {
      localStorage.setItem("reduxState", serializedState);
    }
  } catch (error) {
    console.error("Error saving state:", error);
  }
};

const localStorageMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (typeof window !== "undefined") {
    const state = store.getState();

    const partialState = {
      ui: state.ui,
      user: state.user,
      generates: state.generates,
      games: state.games,
    };

    saveState(partialState);
  }

  return result;
};

export default localStorageMiddleware;
